<template>
  <div id="app">
    <router-view></router-view>
    <questionTip :class="small ? 'tip smallStyle' : 'tip'" v-show="showTip" @close="show=false" @open="open"></questionTip>
    <tipLogged :class="small ? 'tip smallStyle' : 'tip'" :curQestion="curQestion" :num="num" v-show="showTipLogged" @close="haveQuestion=false"></tipLogged>
<!--    <div class="imBox" v-if="token && userType != 2" v-show="($route.path != '/im/chat') && ( $route.path.indexOf('login') < 0)" :class="{imBoxCenter:$route.path.indexOf('/home')==0||$route.path=='/'}">-->
<!--      <el-badge :max="99" :value="totalMsgCount" :hidden="totalMsgCount == 0">-->
<!--        <div class="im" @click="openIM">-->
<!--          <span></span>-->
<!--        </div>-->
<!--      </el-badge>-->
<!--    </div>-->
  </div>
</template>

<script>
import {getToken} from "common/auth"
import {getWebCount,questionnaireUserListPage,unreadMessageCount} from "@/api/index"
import questionTip from "./views/tip.vue"
import tipLogged from "./views/tipLogged.vue"
import {mapState,mapGetters} from "vuex"
import Cookies from "js-cookie"
export default {
  name: 'App',
  components: {
    questionTip,
    tipLogged
  },
  data(){
    return {
      show:false,
      lengthFlag:false,
      tokenFlag:false,
      haveQuestion:false,
      curQestion:{},
      currentPath:false,
      num:1,
      small:false
    }
  },
  computed:{
    showTip(){
      return this.show && this.lengthFlag && this.tokenFlag && this.currentPath && !this.token
      // return this.show && this.lengthFlag && this.tokenFlag && (this.$route.path != '/writeQuestion')&&!this.token
    },
    showTipLogged(){
      return  this.haveQuestion && this.token && (this.userType == 1 || this.userType == 2 || this.userType == 3) && this.currentPath
    },
    ...mapState({
      token:state=>state.loginStore.token,
      userType:state=>state.loginStore.userType,
      userInfo:state=>state.loginStore.userInfo
    }),
    ...mapGetters('imStore',{
      totalMsgCount:'totalMsgCount'
    }),
  },
  watch:{
    userType(val){
      if(val == 1 || val == 2 || val == 3){
        this.getLoggedList()
      }
    },
    userInfo(val){
      if(val.id){
        this.getLoggedList()
      }
    },
    $route(to,from){
      let path = to.path
      this.currentPath = Boolean(path != '/writeQuestion' && path != '/login/studentLogin' && path != '/login/teacherLogin' && path != '/login/companyLogin')
    }
  },
  mounted(){
    new BroadcastChannel('jy').onmessage = (e)=>{
      let obj = e.data
      if(obj.type == 'login'){
        if(obj.code == 1){
          this.$store.commit('loginStore/SET_USER_TYPE',Cookies.get('userType'))
          this.$store.commit('loginStore/SET_TOKEN',getToken())
          this.$store.dispatch('loginStore/getUserRouter',{roleId: this.userInfo.roleId})
          this.$store.dispatch('loginStore/getUserInfoData',{roleId: this.userInfo.roleId}).then(()=>{
            this.$store.dispatch('imStore/userLogin')
          })
        }
      }else if(obj.type == 'logout'){
        this.$store.dispatch('imStore/userLogout')
        location.reload()
      }
    }
    let width = window.innerWidth
    this.small = Boolean(width < 1600)
    new BroadcastChannel('im').onmessage = (e)=>{
      let obj = e.data
      if(obj.type == 'read'){
        if(this.$route.path!=='/im/chat'){
          this.$store.dispatch('imStore/getAccountContactList')
        }
      }
    }
  },
  created(){
    this.getWebCountData()
    this.$store.dispatch('baseStore/initSocket')
    this.$store.dispatch('baseStore/getCodeData')
    this.$store.dispatch('baseStore/getCityData')
    this.$store.dispatch('baseStore/getStudentSourceCityData')
    this.$store.dispatch('homeStore/webConfig')
    this.$store.dispatch('loginStore/getRegistryConfig')
    if(getToken()){
      this.$store.dispatch('loginStore/getUserRouter',{roleId: this.userInfo.roleId})
      this.$store.dispatch('loginStore/getUserInfoData',{roleId: this.userInfo.roleId}).then(()=>{
        this.$store.dispatch('imStore/userLogin')
      })
      this.$store.dispatch('studentManageStore/getEmploymentYearData')
      this.getUnReadMessage()
      this.tokenFlag = false
    }else{
      this.tokenFlag = true
    }
    let flag = sessionStorage.getItem('showToQuestion')
    this.show = typeof(flag)==undefined || flag == null ? true:false
  },
  methods:{
    openIM(){
      this.$store.dispatch('imStore/openIM')
    },
    getUnReadMessage(){
      unreadMessageCount().then(res=>{
        this.$store.commit('baseStore/updateMsgCount',Number(res.data))
      })
    },
    getWebCountData(){
      getWebCount().then(res=>{
        this.$store.commit('baseStore/updateWebCount',res.data)
      })
    },
    // readCookie(name) {
		// 	var nameEQ = name + "=";
		// 	var ca = document.cookie.split(";");
		// 	for(var i = 0; i < ca.length; i++) {
		// 		var c = ca[i];
		// 		while(c.charAt(0) == " ") c = c.substring(1, c.length);
		// 		if(c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		// 	}
		// 	return null;
		// },
    open(){
     this.lengthFlag = true
    },
    getLoggedList(){
      let params = {
        fillingRoles:this.userType,
        isValid:'1',
        fillingStatus:'1',
        current:1,
        size:1000
      }
      if(this.userType == 2){
        params.roleType = this.userInfo.roleType
      }
      questionnaireUserListPage(params).then(res=>{
        if(res.code == 200){
          let arr = res.data.records
          let array = []
          arr.forEach(element => {
            if(element.status){
              array.push(element)
            }
          });
          if(array.length>0){
           this.curQestion =Object.assign(array[0],{userType:this.userType})
           localStorage.setItem('tipLoggedQestion',JSON.stringify(this.curQestion))
           this.haveQuestion = true
           this.num = array.length
          }else{
            this.haveQuestion = false
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.tip{
  position: fixed;
  right: 65px;
  bottom: 20px;
  position: fixed;
  z-index: 30;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;
}
.imBox{
  position: fixed;
  right: 20px;
  bottom: 240px;
  z-index: 40;
  width: 40px;
  height: 40px;
  .im{
    width: 40px;
    height: 40px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    span{
      width:20px;
      height:20px;
      display:block;
      background:url(./assest/images/message.png) center no-repeat;
      background-size:100% 100%;
    }
    &:hover{
      background: #0066FF;
      box-shadow: 0px 0px 2px 0px rgba(0,102,255,0.2);
      span{
        background:url(./assest/images/messageHover.png) center no-repeat;
        background-size:100% 100%;
      }
    }
  }
}
.imBoxCenter{
  bottom: 410px;
}
</style>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,body{
  margin: 0;
  padding: 0;
  background:#f6f6f8;
}
.divFlex{
  display: flex;
  width: 100%;
}
.divFlexAlignCenter{
  align-items: center;
}
.divFlexJustifyCenter{
  justify-content: center;
}
.divFlexJustifyRight{
  justify-content: flex-end;
}
.cursorPointer{
  cursor: pointer;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #f5f5f5;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
</style>
<style lang="less">
.studentManageForm{
  .el-input.is-disabled{
    .el-input__inner{
      color: #888888 !important;
      background-color: #f7f8f9 !important;
      border-color: #efefef !important;
    }
  }
  .el-textarea.is-disabled{
    .el-textarea__inner{
      color: #888888 !important;
      background-color: #f7f8f9 !important;
      border-color: #efefef !important;
    }
  }
}
.searchBox{
  .el-form-item{
    margin-bottom:8px;
    .el-form-item__label{
      line-height:32px;
      font-size: 12px;
    }
    .el-form-item__content{
      font-size: 12px;
      line-height:32px;
      .el-input__inner{
        line-height:32px;
        height:32px !important;
        font-size: 12px;
      }
      .el-input__icon{
        line-height:32px;
      }
      .el-radio__label{
        font-size: 12px;
      }
    }
  }
}
.switchData{
      .el-switch{
        font-size: 12px !important;
        line-height: 14px  !important;
        .el-switch__core{
          width: 30px !important;
          height: 16px   !important;
          &::after{
            width: 14px  !important;
            height: 14px  !important;
            top: 0 ;
            //margin-left: -15px;
          }
        }
        .el-switch__label{
          height: auto;
        }
        .el-switch__label *{
          font-size: 12px  !important;
          height: 14px  !important;
        }
      }
      .is-checked{
        .el-switch__core{
          &::after{
            margin-left: -15px  !important;

          }
        }
      }


}
.tableBox {
  .el-table {
    thead {
      th {
        font-weight: 400;
        padding: 10px 0;
      }

      color: #333;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
    }
    .el-table__body{
      td{
        padding:5px 0;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        .el-button--text{
          padding: 1px 0;
        }
      }
    }
  }
}
.formDataBox{
  /deep/ .el-input.is-disabled .el-input__inner + .el-input__suffix{
    display: none !important;
  }
  .el-form-item{
    margin-bottom:20px;
    .el-form-item{
      margin-bottom:20px;
      &:nth-last-of-type(1){
        margin-bottom:0;
      }
    }
    .el-form-item__label{
      line-height:32px;
      font-size: 12px;
      position:relative;
      padding-left:5px;
    }
    .el-form-item__content{
      line-height:32px;
      font-size: 12px;
      .el-alert{
        padding:0 16px;
        .el-alert__title{
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6509803921568628);
        }
      }
      .el-select{
        display:block;
      }
      .el-radio{
        font-size: 12px;
        .el-radio__label{
          font-size: 12px;
        }
      }
      .el-checkbox__label{
        font-size: 12px;
      }
      .el-date-editor{
        width:100%;
      }
      .el-cascader{
        width: 100%;
        line-height:32px;
      }
      .el-input-number{
        line-height:30px;
        width: 100%;
        font-size: 12px;

      }
      .el-input__inner{
        line-height:32px;
        height:32px;
        font-size: 12px;
      }
      .el-textarea__inner{
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      }
      .el-input__icon{
        line-height:32px;
      }
      .el-upload-list--picture-card,.el-upload--picture-card{
        width:100px;
        height:100px;
        line-height:100px;
        .el-upload-list__item{
          width:100px;
          height:100px;
          line-height:100px;
        }
      }
      .el-upload-list--picture-card{
        display:inline-block;
        width:auto;
      }
      .el-upload__tip{
        display:inline-block;
        margin-left: 10px;
        font-size:12px;
        margin-top: 0;
      }
      .el-textarea{
        .el-input__count{
          line-height:24px;
        }
      }
    }
  }
}
.addStudent{
  /deep/ .el-input.is-disabled .el-input__inner + .el-input__suffix{
    display: none !important;
  }
  .el-form-item{
    margin-bottom:8px;
    .el-form-item{
      margin-bottom:8px;
      &:nth-last-of-type(1){
        margin-bottom:0;
      }
    }
    .el-form-item__label{
      line-height:32px;
      font-size: 12px;
    }
    .el-form-item__content{
      line-height:32px;
      .el-input__inner{
        line-height:32px;
        height:32px;
      }
      .el-input__icon{
        line-height:32px;
      }
    }
  }
}
//弹出框样式
.diaBox{
  /deep/ .el-input.is-disabled .el-input__inner + .el-input__suffix{
    display: none !important;
  }
  .el-form-item{
    margin-bottom:8px;
    .el-form-item{
      margin-bottom:8px;
      &:nth-last-of-type(1){
        margin-bottom:0;
      }
    }
    .el-form-item__label{
      line-height:32px;
      font-size: 12px;
    }
    .el-form-item__content{
      line-height:32px;
      .el-input__inner{
        line-height:32px;
        height:32px;
      }
      .el-input__icon{
        line-height:25px;
      }
      .el-textarea__inner{
        font-family: '';
        font-size: 12px;
      }
    }
    .el-date-editor .el-range-separator{
      line-height: 25px;
    }
  }
}
.el-message{
  z-index:999999 !important;
}

//院系列表字体12px
.treeContent {
  /deep/.el-tree-node__label{
    font-size: 12px!important;
  }
}
//显示排序滚动条样式
.project-dropdown::-webkit-scrollbar
{
  width: 5px;
  background-color: #F5F5F5;
}
.project-dropdown::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}
.project-dropdown::-webkit-scrollbar-thumb{
  border-radius: 10px;
  background-color: #ddd;
}
//显示排序字号12px
.project-dropdown{
  /deep/ .el-dropdown-menu .el-dropdown-menu__item span {
    font-size: 12px!important;
  }
}
// 导入文件字体12px
.exportBlock{
	.el-upload-list__item{
		font-size: 12px;
	}
}
.pageBox{
  margin-top:8px;
  .el-pagination{
    display: flex;
    justify-content:flex-end;
    span:not([class*=suffix]){
      font-size: 12px;
    }
  }
}
.el-tooltip__popper{
  max-width:400px !important;
}
.el-select-dropdown__item{
  font-size:12px !important;
}
.el-cascader-node__label{
  font-size: 12px !important;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
}
.el-tree{
     .el-tree-node__label{
          font-size: 12px !important;
                    }
     }
.el-dropdown-menu{
  .el-dropdown-menu__item{
    span{
      font-size: 12px!important;
    }
  }
}

.el-dropdown-menu::-webkit-scrollbar
{
  width: 5px;
  height: 5px;
  background-color: #F5F5F5;
}
.el-dropdown-menu::-webkit-scrollbar-thumb{
  background-color: #999999;
}
.el-dropdown-menu::-webkit-scrollbar-track{
  background-color: #999999;
}
//双选会样式
.recruitCommon{
  ul,li{
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .divFlex{
    display: flex;
    width: 100%;
  }
  .divFlexAlignCenter{
    align-items: center;
  }
  .divFlexJustifyCenter{
    justify-content: center;
  }
  .divFlexJustifyRight{
    justify-content: flex-end;
  }
  .cursorPointer{
    cursor: pointer;
  }

  .width1200{
    width: 1200px;
    margin: auto;
  }
  .flex{
    display: flex;
  }
  .flexColumn{
    flex-direction: column;
  }
  .justifyCenter{
    justify-content: center;
  }
  .justifyBetween{
    justify-content: space-between;
  }
  .alignCenter{
    align-items: center;
  }
  .alignEnd{
    align-items: flex-end;
  }
  .flexWrap{
    flex-wrap: wrap;
  }
  .flex1{
    flex: 1;
  }
  .textOverflow{
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .textOverflow2{
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.smallStyle{
  scale: 0.8;
}
</style>
